export default __webpack_public_path__ + "static/walmart-removebg-preview-81e8170efd97b64a4ec652fd967ebf7a.png";